import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_QUESTION_TYPES = "/api/question_types"

export async function getQuestionTypes(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTION_TYPES
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getQuestionType(id) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTION_TYPES + "/" + id
  return await getObject(url)
}

export async function putQuestionType(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTION_TYPES + "/" + id
  return await putObject(url, putValues)
}

export async function patchQuestionType(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTION_TYPES + "/" + id
  return await patchObject(url, patchValues)
}

export async function postQuestionType(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_QUESTION_TYPES
  return await postObject(url, postValues)
}
